export default __webpack_public_path__ + "static/media/warehouse.06ab8a83.svg";